import { render } from "./EditPartnerButtonView.vue?vue&type=template&id=3c7789d2&scoped=true"
import script from "./EditPartnerButtonView.vue?vue&type=script&lang=js"
export * from "./EditPartnerButtonView.vue?vue&type=script&lang=js"

import "./EditPartnerButtonView.vue?vue&type=style&index=0&id=3c7789d2&scoped=true&lang=scss"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3c7789d2"]])

export default __exports__